import { GeoPoint } from '../driver/driver.model';

export enum DriverFilterType {
  Proximity = 'PROXIMITY',
  Availability = 'AVAILABILITY', 
  BroomCar = 'BROOM_CAR',
}

export interface GetMapDriversRequest {
  orderHash: string;
  filterType: DriverFilterType;
}

export interface DriverForService {
  driverId: string;
  driverName: string;
  distanceToService: number;
}

export interface OperationResult {
  wasSuccessful: boolean;
  statusCode: string;
  _statusCode: string;
}


export interface MapDriversResponseItem {
  driversForService: DriverForService[];
  operationResult: OperationResult;
}

export type MapDriversResponse = MapDriversResponseItem[];


export interface EpochSeconds {
  seconds: string | number;
}

export interface ServiceFilterData {
  date: {
    seconds: number | null | undefined;
  };
  zoneId: string | null | undefined;
}

export interface ProtoTimestamp {
  seconds: string;
  nanos: number;
}

export interface DriverGeneralInfo {
  driverId: string;                  
  firstName: string;
  lastName: string;
  fullName: string;
  emailAddress: string;
  contactPhoneNumber: string;
  additionalContactPhoneNumber?: string;
  additionalEmailAddress?: string;
  allowedMotorcycleServiceType: 'ALLOWED' | 'NOT_ALLOWED';
  isActive: boolean;
  isInternal: boolean;
  operatorType: 'BROOM_CAR' | 'LONG_DISTANCE' | 'IN_CITY' | string;
  profilePictureUrl: string;
  creationDate: ProtoTimestamp;
  workdayStartTime: ProtoTimestamp;
  workdayEndTime: ProtoTimestamp;
  startAddress: string;
  startAddressDetail: string;
  startAddressPoint: GeoPoint;
  lastLocation: GeoPoint;
  zoneId: string;
}

export interface ActiveDriver {
  driverId: string;
  assignedServices: string[];     
  general_info: DriverGeneralInfo;
}

export interface UnassignedService {
  FormatedHour?: string;
  pickupDate?: { time?: string };
  pickupAddress?: string;
  destinationAddress?: string;
  startUbication?: { latitude: number; longitude: number; address: string };
  endUbication?: { latitude: number; longitude: number; address: string };
  mainProductName?: string;
  productName?: string;
  chassis?: string;
  vehicleType?: string;
  pickupPoint?: GeoPoint;
  destinationPoint?: GeoPoint;
}

export interface ServicesInZoneResponseItem {
  activeDrivers: ActiveDriver[];
  unassignedServices: UnassignedService[];
}

export type ServicesInZoneResponse = ServicesInZoneResponseItem[];